module.exports = __webpack_public_path__ + "YAML.png";